(() => {
  if (customElements.get('nfc-disc-kit-gallery')) return;
  class DiscKitGallery extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.image = this.querySelector('.nfc-disc-kit-image');
      if (!this.image) return;
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-kit-image]');
        if (!button || !this.contains(button)) return;
        this.image.removeAttribute('srcset');
        this.image.removeAttribute('sizes');
        this.image.src = button.dataset.kitImage;
        this.image.alt = button.dataset.kitAlt || '';
        this.querySelectorAll('[data-kit-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('nfc-disc-kit-gallery', DiscKitGallery);
})();
